// extracted by mini-css-extract-plugin
module.exports = {"items":"ReportOrderConfigurationView__items--3hXw3Sm7BotIlO3RLXrgQs"};